import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgLightningIcon(props) {
  return jsx("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "m8.87 16.08-1.12-.58 3.87-7.42H2.15l4-8 1.13.57-3.1 6.17h9.51l-4.82 9.26Z",
    fill: "currentColor"
  }));
}

export { SvgLightningIcon as default };
